import React, { useState } from 'react';
import TimezoneSelect from 'react-timezone-select';

export const TimeZone = () => {
    const [selectedTimezone, setSelectedTimezone] = useState({})
  return (
    <div>
      <div className="select-wrapper">
        <TimezoneSelect
          value={selectedTimezone}
          onChange={setSelectedTimezone}
        />
      </div>
    </div>
  )
}
